<div class="article-wrap">
  <div class="article-panel">
    <!-- Toolbar -->
    <div class="article-toolbar">
      <div class="article-tabs">
        @for (tab of statusTabs; track tab.key) {
          <button class="article-tab" [class.active]="statusFilter === tab.key" (click)="setStatusFilter(tab.key)">
            {{ tab.label }}<span class="article-tab-cnt tnum">{{ tabCounts[tab.key] }}</span>
          </button>
        }
      </div>
      <div class="article-toolbar-spacer"></div>
      <div class="article-search">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round">
          <circle cx="11" cy="11" r="7"/>
          <path d="m20 20-3.2-3.2"/>
        </svg>
        <input [(ngModel)]="searchQuery" (ngModelChange)="onSearchChange()"
               placeholder="ค้นหาชื่อบทความ, alias หรือผู้เขียน…">
        @if (searchQuery) {
          <button class="article-search-clear" (click)="searchQuery = ''; onSearchChange()">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round">
              <path d="M6 6l12 12M18 6 6 18"/>
            </svg>
          </button>
        }
      </div>
      <div class="article-sort-wrap" (mousedown)="$event.stopPropagation()">
        <button class="article-sort-btn" (click)="toggleSortMenu()">
          <svg class="article-sort-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
               stroke-linecap="round" stroke-linejoin="round">
            <path d="M7 4v16m0 0-3-3m3 3 3-3M17 20V4m0 0-3 3m3-3 3 3"/>
          </svg>
          <span>{{ currentSort.label }}</span>
          <svg class="article-sort-caret" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4"
               stroke-linecap="round" stroke-linejoin="round">
            <path d="m6 9 6 6 6-6"/>
          </svg>
        </button>
        @if (sortMenuOpen) {
          <div class="article-menu">
            <div class="article-menu-label">เรียงตาม</div>
            @for (opt of sortOptions; track $index) {
              <button class="article-menu-item" [class.on]="$index === sortIdx" (click)="setSort($index)">
                <span>{{ opt.label }}</span>
                @if ($index === sortIdx) {
                  <svg class="article-menu-check" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"
                       stroke-linecap="round" stroke-linejoin="round">
                    <path d="m5 12 5 5L20 6"/>
                  </svg>
                }
              </button>
            }
          </div>
        }
      </div>
    </div>

    <!-- Bulk Action Bar -->
    @if (selectedIds.size > 0) {
      <div class="article-bulkbar">
        <span class="article-bulk-count">เลือกแล้ว <b class="tnum">{{ selectedIds.size }}</b> รายการ</span>
        <span class="article-bulk-sep"></span>
        <button class="article-bulk-btn" (click)="bulkPublish()">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
               stroke-linejoin="round">
            <path d="M12 16V4m0 0L8 8m4-4 4 4M4 16v3a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-3"/>
          </svg>
          เผยแพร่
        </button>
        <button class="article-bulk-btn" (click)="bulkUnpublish()">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
               stroke-linejoin="round">
            <path
              d="M9.9 4.2A9.6 9.6 0 0 1 12 4c6.5 0 10 7 10 7a16 16 0 0 1-2.6 3.4M6.6 6.6A16 16 0 0 0 2 11s3.5 7 10 7a9.4 9.4 0 0 0 4.4-1M3 3l18 18"/>
          </svg>
          ยกเลิกเผยแพร่
        </button>
        <button class="article-bulk-btn article-bulk-btn-danger" (click)="bulkDelete()">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
               stroke-linejoin="round">
            <path d="M3 6h18M8 6V4a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v2m2 0v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6"/>
          </svg>
          ลบ
        </button>
        <button class="article-bulk-close" (click)="clearSelection()" title="ยกเลิกการเลือก">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round">
            <path d="M6 6l12 12M18 6 6 18"/>
          </svg>
        </button>
      </div>
    }

    <!-- List Header -->
    @if (selectedIds.size === 0) {
      <div class="article-list-header">
        <input type="checkbox" class="form-check-input table-checkbox" [checked]="isAllPageSelected"
               (change)="toggleSelectAll()">
        <span class="article-col-header">
          <span class="article-col-sort" [class.active]="currentSort.field === 'title'"
                (click)="toggleSortDir('title')">
            หัวเรื่อง
            @if (currentSort.field === 'title') {
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"
                   stroke-linejoin="round"><path d="m6 9 6 6 6-6"/></svg>
            }
          </span>
        </span>
        <span>ผู้เขียน</span>
        <span class="article-col-right">
          <span class="article-col-sort" [class.active]="currentSort.field === 'hits'" (click)="toggleSortDir('hits')">
            ยอดเข้าชม
            @if (currentSort.field === 'hits') {
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"
                   stroke-linejoin="round"><path d="m6 9 6 6 6-6"/></svg>
            }
          </span>
        </span>
        <span>
          <span class="article-col-sort" [class.active]="currentSort.field === 'publishUp'"
                (click)="toggleSortDir('publishUp')">
            วันที่
            @if (currentSort.field === 'publishUp') {
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"
                   stroke-linejoin="round"><path d="m6 9 6 6 6-6"/></svg>
            }
          </span>
        </span>
        <span>สถานะ</span>
        <span class="article-col-right">จัดการ</span>
      </div>
    }

    <!-- Rows -->
    <div class="article-rows">
      @if (isLoading) {
        <div class="article-loading">
          <div class="article-loading-spinner"></div>
        </div>
      } @else if (displayedItems.length === 0) {
        <div class="article-empty">
          <div class="article-empty-icon">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                 stroke-linejoin="round">
              <path d="M22 12h-6l-2 3h-4l-2-3H2"/>
              <path d="M5.5 6 2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.5-6Z"/>
            </svg>
          </div>
          <h3>ไม่พบบทความที่ตรงกับเงื่อนไข</h3>
          <p>ลองปรับคำค้นหรือเปลี่ยนตัวกรองสถานะ</p>
        </div>
      } @else {
        @for (item of displayedItems; track item.id) {
          <div class="article-row" [class.sel]="selectedIds.has(item.id)">
            <!-- Checkbox -->
            <input type="checkbox" class="form-check-input table-checkbox"
                   [checked]="selectedIds.has(item.id)" (change)="toggleSelect(item.id)">

            <!-- Title cell -->
            <div class="article-titlecell">
              <span class="article-ticon doc">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                     stroke-linejoin="round"><path d="M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8z"/><path
                  d="M14 3v5h5M9 13h6M9 17h6"/></svg>
              </span>
              <span class="article-tmeta">
                <a class="article-ttitle" href="#" (click)="$event.preventDefault(); openDetail(item)"
                   title="{{ item.title }}">{{ item.title || '-' }}</a>
                <span class="article-tsub">
                  <span class="article-alias">{{ item.alias || '-' }}</span>
                </span>
              </span>
            </div>

            <!-- Author cell -->
            <div class="article-authorcell">
<!--              <span class="article-a-ava"-->
<!--                    [style.background]="getAuthorColor(item.createdByAlias)">{{ getInitial(item.createdByAlias) }}</span>-->
              <span class="article-a-nm">{{ item.createdByAlias || '-' }}</span>
            </div>

            <!-- Hits cell -->
            <div class="article-hitscell">
              <span class="article-hn tnum">
<app-search-icon [size]="18"></app-search-icon>
                {{ getHitDisplay(item.hits) }}
              </span>
              <span class="article-hl">เข้าชม</span>
            </div>

            <!-- Date cell -->
            <div class="article-datecell tnum">
              {{ (item.publishUp || item.modified || item.created) | thDateDisplay:true }}
<!--              <span class="article-dl">{{ item.state === 1 ? 'เผยแพร่' : 'แก้ไขล่าสุด' }}</span>-->
            </div>

            <!-- Status cell -->
            <div class="article-stwrap">
              <span class="article-pill" [class.pub]="item.state === 1" [class.unpub]="item.state !== 1">
                <span class="article-pill-dot"></span>
                {{ item.state === 1 ? 'เผยแพร่' : 'ไม่เผยแพร่' }}
              </span>
            </div>

            <!-- Actions cell -->
            <div class="article-actcell">
              <button class="article-iconbtn" (click)="openEditPage(item)" title="แก้ไข">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                     stroke-linejoin="round">
                  <path d="M12 20h9"/>
                  <path d="M16.5 3.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4Z"/>
                </svg>
              </button>
              <button class="article-iconbtn" (click)="openPublicPage(item)" title="เปิดหน้า Public">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                     stroke-linejoin="round">
                  <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"/>
                  <polyline points="15 3 21 3 21 9"/>
                  <line x1="10" y1="14" x2="21" y2="3"/>
                </svg>
              </button>
            </div>
          </div>
        }
      }
    </div>

    <!-- Footer -->
    <div class="article-list-foot">
      <span class="article-showing">
        แสดง <b
        class="tnum">{{ displayedItems.length > 0 ? (page - 1) * pageSize + 1 : 0 }}&ndash;{{ (page - 1) * pageSize + displayedItems.length }}</b> จาก <b
        class="tnum">{{ collectionSize }}</b> รายการ
      </span>
      <div class="article-foot-right">
        <div class="article-perpage">
          <span>ต่อหน้า</span>
          <div class="article-pp-sel" (mousedown)="$event.stopPropagation()">
            <button class="article-pp-btn tnum" (click)="togglePpMenu()">
              {{ pageSize }}
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"
                   stroke-linejoin="round">
                <path d="m6 9 6 6 6-6"/>
              </svg>
            </button>
            @if (ppMenuOpen) {
              <div class="article-menu article-menu-up">
                @for (size of pageSizes; track size) {
                  <button class="article-menu-item tnum" [class.on]="size === pageSize"
                          (click)="pageSize = size; onPageSizeChange(); closePpMenu()">
                    <span>{{ size }}</span>
                    @if (size === pageSize) {
                      <svg class="article-menu-check" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                           stroke-width="3" stroke-linecap="round" stroke-linejoin="round">
                        <path d="m5 12 5 5L20 6"/>
                      </svg>
                    }
                  </button>
                }
              </div>
            }
          </div>
        </div>

        <ngb-pagination
          [collectionSize]="collectionSize"
          [(page)]="page"
          [pageSize]="pageSize"
          [maxSize]="5"
          [rotate]="true"
          [boundaryLinks]="true"
          (pageChange)="load()"
        ></ngb-pagination>
      </div>
    </div>
  </div>
</div>
